export const pinLoginDutch = {
  lang: 'nl',
  data: {
    PIN: {
      MESSAGE: 'Voer de sms code in',
      SUBMIT: 'Verstuur',
      PASSWORD: 'Wachtwoord',
      ERROR: 'Code incorrect',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/2fa/i18n/nl.ts